/**
 * Local-first progress store for Cosmos Brain Power games.
 * No backend: everything persists in localStorage so any of the three games
 * works standalone, offline, and inside the Unity embed.
 */

const KEY = 'cbp.progress.v1'

function freshState() {
  return {
    version: 1,
    bp: 0,
    streak: 0,
    lastDay: null,
    played: {},
    detective: { solved: 0, attempts: 0, bestStreak: 0, currentStreak: 0 },
    eco: { plays: 0, best: { digits: 0, reverse: 0, visual: 0, words: 0 } },
    duelo: { elo: 1000, wins: 0, losses: 0, draws: 0, plays: 0, byCat: {} },
  }
}

export function todayKey(d = new Date()) {
  return d.toISOString().slice(0, 10)
}

export function load() {
  if (typeof localStorage === 'undefined') return freshState()
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return freshState()
    const parsed = JSON.parse(raw)
    return { ...freshState(), ...parsed }
  } catch {
    return freshState()
  }
}

export function save(state) {
  if (typeof localStorage === 'undefined') return state
  try {
    localStorage.setItem(KEY, JSON.stringify(state))
  } catch {
    /* quota / private mode: analytics never breaks the game */
  }
  return state
}

export function update(fn) {
  const next = fn(load()) || load()
  return save(next)
}

/** Bump the day streak once per calendar day. */
export function touchStreak(state) {
  const today = todayKey()
  if (state.lastDay === today) return state
  const yesterday = todayKey(new Date(Date.now() - 86400000))
  state.streak = state.lastDay === yesterday ? (state.streak || 0) + 1 : 1
  state.lastDay = today
  return state
}

export function awardBp(amount) {
  return update((s) => {
    touchStreak(s)
    s.bp = (s.bp || 0) + amount
    return s
  })
}

/** Standard Elo: returns the new rating for player A. */
export function eloDelta(ratingA, ratingB, scoreA, k = 32) {
  const expected = 1 / (1 + Math.pow(10, (ratingB - ratingA) / 400))
  return Math.round(k * (scoreA - expected))
}
